import * as x from "react";
import { n as r } from "../property-9daa16cd.mjs";
import { i as m, b, E as f, x as h, a as k, r as v, c as u } from "../createReactComponent-58f9bea8.mjs";
import { e as p } from "../class-map-2994e95e.mjs";
import { r as _ } from "../icon-c572aa57.mjs";
var w = Object.defineProperty, E = Object.getOwnPropertyDescriptor, s = (t, e, o, a) => {
  for (var l, n = a > 1 ? void 0 : a ? E(e, o) : e, c = t.length - 1; c >= 0; c--)
    (l = t[c]) && (n = (a ? l(e, o, n) : l(n)) || n);
  return a && n && w(e, o, n), n;
}, I = ((t) => (t.ELEVATED = "elevated", t.FLAT = "flat", t))(I || {});
function $(t) {
  return new Promise((e) => setTimeout(e, t));
}
class i extends f {
  constructor() {
    super(...arguments), this.open = !1, this.label = "", this.leadingIcon = "", this.variant = "flat", this.leadingIconLabel = "", this.observer = null, this.onKeyPress = (e) => {
      e.code !== "Enter" && e.code !== "Space" || (e.preventDefault(), this.toggle());
    }, this.animateHeight = () => {
      var o;
      const e = (o = this.shadowRoot) == null ? void 0 : o.querySelector("#content");
      e && async function(a, l, n) {
        let c = 30;
        const g = (l - a) / 30;
        do
          n.style.maxHeight = `${Math.abs(n.offsetHeight + g)}px`, c -= 1, await $(10);
        while (c > 0);
        n.style.maxHeight = g < 0 ? "0" : "100%";
      }(e.offsetHeight, this.open ? e.scrollHeight : 0, e);
    };
  }
  dispatchToggleEvent() {
    this.dispatchCustomEvent("on-toggle", { detail: { data: { ...this.dataset }, open: this.open } });
  }
  onClick(e) {
    e.currentTarget.focus(), this.toggle();
  }
  toggle() {
    this.open = !this.open, this.dispatchToggleEvent(), this.animateHeight();
  }
  connectedCallback() {
    super.connectedCallback();
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this.observer) == null || e.disconnect();
  }
  getLeadingIcon() {
    return this.leadingIcon.trim() ? h`<ex-icon
        icon="${this.leadingIcon.trim()}"
        variant="tertiary"
        size="XS"
        label=${this.leadingIconLabel}
      ></ex-icon>` : k;
  }
  render() {
    return h`<div
      class=${p({ container: !0, "container--variant__elevated": this.variant !== "flat", "container--variant__flat": this.variant === "flat", open: this.open })}
    >
      <div
        id="header"
        part="header"
        @click=${this.onClick}
        @keypress=${this.onKeyPress}
        tabindex="0"
        role="button"
      >
        <div>
          ${this.getLeadingIcon()}
          <h3
            id="header_label"
            aria-expanded=${this.open}
            aria-controls="content"
            part="header-label"
            tabindex="-1"
          >
            ${this.label}
          </h3>
        </div>
        <div class="header-suffix">
          <slot name="header-suffix"></slot>
          <ex-icon
            class="${p({ open: this.open })}"
            icon="${this.open ? "Up caret" : "Down caret"}"
            variant="tertiary"
          ></ex-icon>
        </div>
      </div>
      <div
        part="content"
        id="content"
        role="region"
        aria-labelledby="header_label"
      >
        <div>
          <slot></slot>
        </div>
      </div>
    </div>`;
  }
}
i.styles = m`
    ${b(`:host{--exo-component-accordion-content-max-height: 100vh;--exo-component-accordion-content-label-size: var(--exo-font-size-small);--exo-component-accordion-content-height: auto}:host .container{padding:var(--exo-spacing-x-small);border-radius:var(--exo-spacing-x-small)}:host .container.container--variant__elevated{display:block;box-shadow:0 1px 2px #00000026;background:var(--exo-color-background);border:1px solid var(--exo-color-border-secondary)}:host .container.container--variant__flat{display:block;position:relative}:host .container.container--variant__flat:after{content:" ";position:absolute;border-bottom:1px solid var(--exo-color-border-secondary);width:calc(100% - 40px);left:50%;bottom:0;transform:translate(-50%)}:host .container #header{display:flex;justify-content:space-between;align-items:center;padding-right:var(--exo-spacing-small);cursor:pointer}:host .container #header>div:not(.header-suffix){display:flex;justify-content:left;align-items:center;gap:var(--exo-spacing-2x-small);padding:var(--exo-spacing-x-small) var(--exo-spacing-small)}:host .container #header>div:not(.header-suffix) #header_label{font-size:var(--exo-component-accordion-content-label-size);font-weight:var(--exo-font-weight-semi-bold);line-height:var(--exo-line-height-denser);text-align:left;margin:0}:host .container #header .header-suffix{display:flex;align-items:center}:host .container #header ex-icon{width:var(--exo-spacing-large);height:var(--exo-spacing-large);border-radius:var(--exo-spacing-2x-small);display:flex;justify-content:center;align-items:center}:host .container #header ex-icon.open{background:var(--exo-color-background-secondary-selected-weak)}:host .container #header ex-icon::part(fillable){fill:var(--exo-color-background-deselected)}:host .container #header:hover{background:var(--exo-color-background-action-hover-weak);border-radius:var(--exo-spacing-x-small)}:host .container #header:hover ex-icon::part(fillable){fill:var(--exo-color-background-deselected-hover)}:host .container #content{visibility:hidden;height:var(--exo-component-accordion-content-height);transition:opacity .3s ease,height .3s ease;opacity:0;max-height:0;overflow:hidden}:host .container #content div{padding:var(--exo-spacing-standard) var(--exo-spacing-small) var(--exo-spacing-small)}:host .container.open #content{visibility:visible;height:var(--exo-component-accordion-content-height);display:block;opacity:1;max-height:var(--exo-component-accordion-content-max-height);transition:opacity .3s ease,max-height 0s ease}:host .container.open #header ex-icon::part(fillable){fill:var(--exo-color-background-selected)}:host(:focus) .container #header,:host(:focus-visible) .container #header{background:var(--exo-color-background-action-hover-weak);outline:2px solid var(--exo-color-background-action-hover);border-radius:var(--exo-spacing-2x-small)}
`)}
  `, s([r({ type: Boolean, reflect: !0 })], i.prototype, "open", 2), s([r({ type: String })], i.prototype, "label", 2), s([r({ type: String, attribute: "leading-icon" })], i.prototype, "leadingIcon", 2), s([r({ type: String })], i.prototype, "variant", 2), s([r({ type: String })], i.prototype, "leadingIconLabel", 2);
class d extends f {
  constructor() {
    super(...arguments), this.variant = "elevated", this.allowMultiple = !1;
  }
  onToggle(e) {
    const o = e.target;
    this.allowMultiple || this.accordionItems.forEach((a) => {
      a !== o && a.open && (a.open = !1, a.animateHeight());
    });
  }
  firstUpdated() {
    const e = Array.prototype.slice.call(this.children);
    this.accordionItems = e.map((o) => (o.setAttribute("variant", this.variant), o.addEventListener("on-toggle", this.onToggle.bind(this)), o));
  }
  render() {
    return h`<div
      class=${p({ container: !0, "container--variant__elevated": this.variant !== "flat", "container--variant__flat": this.variant === "flat" })}
    >
      <slot></slot>
    </div>`;
  }
}
d.styles = m`
    ${b(`.container{display:flex;flex-direction:column}.container.container--variant__elevated{gap:var(--exo-spacing-standard)}.container.container--variant__flat{gap:var(--exo-spacing-none)}
`)}
  `, s([r({ type: String })], d.prototype, "variant", 2), s([r({ type: Boolean, reflect: !0, attribute: "allow-multiple" })], d.prototype, "allowMultiple", 2);
const y = (t = "") => {
  v("ex-accordion-item", i, t), v("ex-accordion", d, t), _(t);
}, L = u({ tagName: "ex-accordion", elementClass: d, react: x, events: {}, displayName: "ExAccordion", registerWebComponent: y }), S = u({ tagName: "ex-accordion-item", elementClass: i, react: x, events: { onToggle: "on-toggle" }, displayName: "ExAccordionItem", registerWebComponent: y });
export {
  d as Accordion,
  i as AccordionItem,
  I as AccordionVariant,
  L as ExAccordion,
  S as ExAccordionItem,
  y as register
};
